import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpEventType, HttpErrorResponse } from '@angular/common/http'
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';
import { Router } from '@angular/router';
import { SharedFormService } from './shared-form.service';
import { SharedStateService } from './shared-state.service';

@Injectable({
    providedIn: 'root'
  })
  export class AuthHeaderInterceptor implements HttpInterceptor {
      
      isRefresh: boolean = false;
     constructor(private router: Router, private stateSvc: SharedStateService, private formData: SharedFormService) {
        this.formData.isRefreshCalled.subscribe((evt) => {
          this.isRefresh = evt;
        });
      }
      intercept(req:HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        while (this.isRefresh && !req.url.includes("refreshToken")) {
          console.log("paused");
        }
        const jwt: string = localStorage.getItem('jwt');
         if((req.url.indexOf('account') > 0 && req.url.indexOf('reset') < 0 && req.url.indexOf('inuse') < 0 && (req.url.indexOf('@') > 0 || req.url.indexOf('password') > 0)) || 
             (req.url.indexOf('provider') > 0 && (req.url.indexOf('cases') > 0 || req.url.indexOf('alerts') > 0)) ||
             req.url.indexOf('cases') > 0 || req.url.indexOf('case') > 0 || req.url.indexOf('documents') > 0 || req.url.indexOf('notes') > 0 ||
             req.url.indexOf('messages') > 0){
            
            if (jwt) {
              req = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${jwt}`
                  },
                  headers: req.headers.set('ClientId', environment.clientId)
                });
            }
         } else if(!req.url.includes("website/public/enrollCase")){
            req = req.clone({
              headers: req.headers.set('ClientId', environment.clientId)
            });
          }
        
         
          return next.handle(req).pipe(
            catchError( (error: HttpErrorResponse) => {
              let errorMsg = '';
                if (error.error instanceof ErrorEvent) {
                  
                  errorMsg = `Error: ${error.error.message}`;
                }
                else {
                  console.log('Here error it is => ', error)
                  const message = error.error.Errors && error.error.Errors.length ? error.error.Errors[0] : error.message;
                  errorMsg = `Error Code: ${error.status},  Message: ${message}`;
                  const jwtErrors = [2, 201, 200, 202, 203, 204, 205, 206]
                  if ((error.status == 401 || error.status == 403) && jwt ) {
                    // this.stateSvc.PrimaryState.loginMessage = 'Session has expired. Please re-login.'
                    this.router.navigate(['/logout']);
                  }
                  if (jwtErrors.includes(error.status)) {
                    this.stateSvc.PrimaryState.loginMessage = 'Session has expired. Please re-login.'
                   // this.router.navigate(['/login']);
                  }
                  
                }

                
              return throwError(errorMsg);
            })
          );
      }
  }